import React from 'react';

/**
 * Kapsam seçim kartı.
 *
 * Ant Card'ın hoverable + onClick kombinasyonu klavyeyle erişilemiyordu; burada
 * kart gerçek bir <button> olduğu için Tab/Enter/Space ve odak halkası bedava geliyor.
 * Kart üstündeki menü gibi ikincil aksiyonlar `menu` slotuna veriliyor ki
 * iç içe buton oluşmasın.
 */
const ScopeCard = ({ label, selected, onSelect, menu, children }) => (
    <div style={{ position: 'relative', height: '100%' }}>
        <button
            type="button"
            className={`scope-card${selected ? ' scope-card--selected' : ''}`}
            aria-pressed={selected}
            aria-label={label}
            onClick={onSelect}
        >
            {children}
        </button>
        {menu && <div className="scope-card__menu">{menu}</div>}
    </div>
);

export default ScopeCard;
